/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateStorefrontScriptsRequestInnerScripts
 */
export interface UpdateStorefrontScriptsRequestInnerScripts {
    /**
     * 
     * @type {string}
     * @memberof UpdateStorefrontScriptsRequestInnerScripts
     */
    pageviewHeaderScripts: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStorefrontScriptsRequestInnerScripts
     */
    pageviewBodyScripts: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStorefrontScriptsRequestInnerScripts
     */
    conversionScripts: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStorefrontScriptsRequestInnerScripts
     */
    googleAnalyticsId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStorefrontScriptsRequestInnerScripts
     */
    facebookAnalyticsId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStorefrontScriptsRequestInnerScripts
     */
    metaConversionApiToken: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateStorefrontScriptsRequestInnerScripts
     */
    googleTagManagerId: string;
}

/**
 * Check if a given object implements the UpdateStorefrontScriptsRequestInnerScripts interface.
 */
export function instanceOfUpdateStorefrontScriptsRequestInnerScripts(value: object): value is UpdateStorefrontScriptsRequestInnerScripts {
    if (!('pageviewHeaderScripts' in value) || value['pageviewHeaderScripts'] === undefined) return false;
    if (!('pageviewBodyScripts' in value) || value['pageviewBodyScripts'] === undefined) return false;
    if (!('conversionScripts' in value) || value['conversionScripts'] === undefined) return false;
    if (!('googleAnalyticsId' in value) || value['googleAnalyticsId'] === undefined) return false;
    if (!('facebookAnalyticsId' in value) || value['facebookAnalyticsId'] === undefined) return false;
    if (!('metaConversionApiToken' in value) || value['metaConversionApiToken'] === undefined) return false;
    if (!('googleTagManagerId' in value) || value['googleTagManagerId'] === undefined) return false;
    return true;
}

export function UpdateStorefrontScriptsRequestInnerScriptsFromJSON(json: any): UpdateStorefrontScriptsRequestInnerScripts {
    return UpdateStorefrontScriptsRequestInnerScriptsFromJSONTyped(json, false);
}

export function UpdateStorefrontScriptsRequestInnerScriptsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateStorefrontScriptsRequestInnerScripts {
    if (json == null) {
        return json;
    }
    return {
        
        'pageviewHeaderScripts': json['pageviewHeaderScripts'],
        'pageviewBodyScripts': json['pageviewBodyScripts'],
        'conversionScripts': json['conversionScripts'],
        'googleAnalyticsId': json['googleAnalyticsId'],
        'facebookAnalyticsId': json['facebookAnalyticsId'],
        'metaConversionApiToken': json['metaConversionApiToken'],
        'googleTagManagerId': json['googleTagManagerId'],
    };
}

export function UpdateStorefrontScriptsRequestInnerScriptsToJSON(json: any): UpdateStorefrontScriptsRequestInnerScripts {
    return UpdateStorefrontScriptsRequestInnerScriptsToJSONTyped(json, false);
}

export function UpdateStorefrontScriptsRequestInnerScriptsToJSONTyped(value?: UpdateStorefrontScriptsRequestInnerScripts | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageviewHeaderScripts': value['pageviewHeaderScripts'],
        'pageviewBodyScripts': value['pageviewBodyScripts'],
        'conversionScripts': value['conversionScripts'],
        'googleAnalyticsId': value['googleAnalyticsId'],
        'facebookAnalyticsId': value['facebookAnalyticsId'],
        'metaConversionApiToken': value['metaConversionApiToken'],
        'googleTagManagerId': value['googleTagManagerId'],
    };
}

